import { getHeaders } from './apiUtils';
import { API_PATHS } from '../types/apiPaths';
var BASE = API_PATHS.CZNA_AUTHORITIES_ERROR_REPORTS;
/** CZNA-1596 — a filter left undefined is not sent: the backend then applies none. */
export var fetchErrorReports = function (ky, params) {
    var searchParams = new URLSearchParams();
    if (params.status)
        searchParams.set('status', params.status);
    if (params.recordId)
        searchParams.set('recordId', params.recordId);
    searchParams.set('offset', String(params.offset));
    searchParams.set('limit', String(params.limit));
    return ky.get("".concat(BASE, "?").concat(searchParams), { headers: getHeaders() })
        .json();
};
export var fetchErrorReport = function (ky, id) {
    return ky.get("".concat(BASE, "/").concat(id), { headers: getHeaders() }).json();
};
export var fetchErrorReportSummary = function (ky) {
    return ky.get("".concat(BASE, "/summary"), { headers: getHeaders() }).json();
};
export var changeErrorReportStatus = function (ky, id, body) {
    return ky.post("".concat(BASE, "/").concat(id, "/status"), { headers: getHeaders(), json: body }).json();
};
export var fetchRecordOpenErrorReports = function (ky, recordId) {
    return ky.get("".concat(API_PATHS.CZNA_AUTHORITIES_RECORDS, "/").concat(recordId, "/error-reports/open"), {
        headers: getHeaders(),
    }).json();
};
